import SliderAlmostFull from './sliderAlmostFull';

export default SliderAlmostFull;
